import { render, staticRenderFns } from "./EstimateTimeSetting.vue?vue&type=template&id=2bc2b2a7&scoped=true"
import script from "./EstimateTimeSetting.vue?vue&type=script&lang=js"
export * from "./EstimateTimeSetting.vue?vue&type=script&lang=js"
import style0 from "./EstimateTimeSetting.vue?vue&type=style&index=0&id=2bc2b2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc2b2a7",
  null
  
)

export default component.exports